import { render } from "./HelpPageFAQ.vue?vue&type=template&id=ede8a4da&scoped=true"
const script = {}

import "./HelpPageFAQ.vue?vue&type=style&index=0&id=ede8a4da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ede8a4da"]])

export default __exports__